import { render, staticRenderFns } from "./out_sourcing_recruit_detail.vue?vue&type=template&id=842bab40&scoped=true"
import script from "./out_sourcing_recruit_detail.vue?vue&type=script&lang=js"
export * from "./out_sourcing_recruit_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842bab40",
  null
  
)

export default component.exports